import { render } from "./RegistroUsuarios.vue?vue&type=template&id=047a7166&scoped=true"
import script from "./RegistroUsuarios.vue?vue&type=script&lang=js"
export * from "./RegistroUsuarios.vue?vue&type=script&lang=js"

import "./RegistroUsuarios.vue?vue&type=style&index=0&id=047a7166&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047a7166"]])

export default __exports__